/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Zoom_InInputs */

const en_read_along_zoom_in = /** @type {(inputs: Read_Along_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom in`)
};

const es_read_along_zoom_in = /** @type {(inputs: Read_Along_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acercar`)
};

/**
* | output |
* | --- |
* | "Zoom in" |
*
* @param {Read_Along_Zoom_InInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_zoom_in = /** @type {((inputs?: Read_Along_Zoom_InInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Zoom_InInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_zoom_in(inputs)
	return en_read_along_zoom_in(inputs)
});